import { render, staticRenderFns } from "./DetailProductSubcategoryComponent.vue?vue&type=template&id=05712c9e&scoped=true"
import script from "./DetailProductSubcategoryComponent.vue?vue&type=script&lang=js"
export * from "./DetailProductSubcategoryComponent.vue?vue&type=script&lang=js"
import style0 from "./DetailProductSubcategoryComponent.vue?vue&type=style&index=0&id=05712c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05712c9e",
  null
  
)

export default component.exports